export default __webpack_public_path__ + "static/media/tent&stars.828e0d94.jpg";